import { useState } from "react";
import publicApi from "../api/axiosPublic";
import "../styles/contacto.css";

export default function Contacto() {
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    telefono: "",
    tipo: "",
    mensaje: "",
  });

  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await publicApi.post("/contacto", form);
      setEnviado(true);
      setForm({
        nombre: "",
        email: "",
        telefono: "",
        tipo: "",
        mensaje: "",
      });
    } catch {
      alert("Ocurrió un error al enviar el mensaje");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contacto-container">
      <div className="contacto-card">

        <h1>¿En qué podemos ayudarte?</h1>
        <p className="contacto-subtitle">
          Escríbenos y nuestro equipo te responderá a la brevedad.
        </p>

        {enviado && (
          <div className="contacto-success">
            ✅ Tu mensaje fue enviado correctamente.  
            Te responderemos pronto.
          </div>
        )}

        <form onSubmit={handleSubmit} className="contacto-form">
          <input
            name="nombre"
            placeholder="👤 Nombre completo"
            value={form.nombre}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="📧 Correo electrónico"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="telefono"
            placeholder="📞 Teléfono"
            value={form.telefono}
            onChange={handleChange}
            required
          />

          <select
            name="tipo"
            value={form.tipo}
            onChange={handleChange}
            required
          >
            <option value="">📌 Motivo de contacto</option>
            <option value="Consulta o duda">Consulta o duda</option>
            <option value="Ayuda o problemas de compra">
              Ayuda o problemas de compra
            </option>
            <option value="Trabaja con nosotros">Trabaja con nosotros</option>
            <option value="Otro">Otro</option>
          </select>

          <textarea
            name="mensaje"
            placeholder="💬 Escribe tu mensaje aquí"
            value={form.mensaje}
            onChange={handleChange}
            required
            rows={4}
          />

          <button type="submit" disabled={loading}>
            {loading ? "Enviando..." : "Enviar mensaje"}
          </button>
        </form>

        <div className="contacto-info">
          <p><strong>📩 Email:</strong> contacto@centromillennials.com</p>
          <p><strong>⏱ Horario:</strong> Lunes a Viernes · 9:00 a 18:00</p>
        </div>

      </div>
    </div>
  );
}
